export const userRules = {
    'department-select': {
        required: true
    }
};
